import { IActions, IModules, IPermission, IPermissionUI } from "../models";
import { CommonService } from "../services";


export class Permissions {

    static transformPermissionsFromAPIToUI(permissions: IPermission[], actions: IActions[], modules: IModules[]): IPermissionUI[] {
        return modules?.map(m => {
            const permissionUIObj: IPermissionUI = {
                id: 0,
                role: 0,
                role_name: '',
                module_name: m.name,
                module_id: m.id,
                view: false,
                add: false,
                edit: false,
                delete: false,
                full: false,
                business: 0
            };

            actions?.forEach(a => {
                const permission = permissions.find(p => p.module === m.id && p.action === a.id);
                const isEnabled = permission?.is_enabled ?? false;

                permissionUIObj.id = permission?.id ? permission.id : 0;
                permissionUIObj.role = permission?.role ? permission.role : 0;
                permissionUIObj.role_name = permission?.role_name ? permission.role_name : '';
                permissionUIObj.business = permission?.business ? permission.business : 0;

                switch (a.name.toLowerCase()) {
                    case 'view':
                        permissionUIObj.view = isEnabled;
                        break;
                    case 'add':
                        permissionUIObj.add = isEnabled;
                        break;
                    case 'edit':
                        permissionUIObj.edit = isEnabled;
                        break;
                    case 'delete':
                        permissionUIObj.delete = isEnabled;
                        break;
                }
            });

            return permissionUIObj;
        }) ?? [];
    }

    static transformPermissionsFromUIToAPI(permissionUI: IPermissionUI[], actions: IActions[], modules: IModules[]): IPermission[] {
        const permissions: IPermission[] = [];

        permissionUI?.forEach(ui => {
            const module = modules.find(m => m.id === ui.module_id);
            if (!module) return;

            actions?.forEach(a => {
                const actionName = a.name.toLowerCase();
                let isEnabled = false;

                switch (actionName) {
                    case 'view':
                        isEnabled = ui.view;
                        break;
                    case 'add':
                        isEnabled = ui.add;
                        break;
                    case 'edit':
                        isEnabled = ui.edit;
                        break;
                    case 'delete':
                        isEnabled = ui.delete;
                        break;
                    default:
                        return; // skip unknown actions
                }

                permissions.push({
                    id: ui.id,
                    role: ui.role,
                    role_name: ui.role_name,
                    module: module.id,
                    module_name: module.name,
                    action: a.id,
                    action_name: a.name,
                    business: ui.business,
                    is_enabled: isEnabled

                } as IPermission);
            });
        });

        return permissions;
    }

    static canView(screen_name: string, commonService: CommonService) {
        if (commonService.profileDetail.is_admin) {
            return true;
        }
        const permissions = commonService.userPermission;
        const permission = permissions.find(p => p.module_name.toLocaleLowerCase() === screen_name.toLocaleLowerCase() && p.action_name.toLowerCase() == 'view');
        return permission?.is_enabled == true ? true : false;
    }

    static canAdd(screen_name: string, commonService: CommonService) {
        if (commonService.profileDetail.is_admin) {
            return true;
        }
        const permissions = commonService.userPermission;
        const permission = permissions.find(p => p.module_name.toLocaleLowerCase() === screen_name.toLocaleLowerCase() && p.action_name.toLowerCase() == 'add');
        return permission?.is_enabled == true ? true : false;
    }

    static canEdit(screen_name: string, commonService: CommonService) {
        if (commonService.profileDetail.is_admin) {
            return true;
        }
        const permissions = commonService.userPermission;
        const permission = permissions.find(p => p.module_name.toLocaleLowerCase() === screen_name.toLocaleLowerCase() && p.action_name.toLowerCase() == 'edit');
        return permission?.is_enabled == true ? true : false;
    }

    static canDelete(screen_name: string, commonService: CommonService) {
        if (commonService.profileDetail.is_admin) {
            return true;
        }
        const permissions = commonService.userPermission;
        const permission = permissions.find(p => p.module_name.toLocaleLowerCase() === screen_name.toLocaleLowerCase() && p.action_name.toLowerCase() == 'delete');
        return permission?.is_enabled == true ? true : false;
    }

}